import { AccountFragment, SubscriptionStatus } from 'src/graphql'

import { SYSTEM_SEND_STRIPE_ID } from 'src/marketing/plans/constants'

const hasSystemPackage = (account: AccountFragment): boolean => {
  const subscriptions = account.subscriptions
  if (!subscriptions) {
    return false
  }
  return subscriptions.some(
    s =>
      (s.status === SubscriptionStatus.ACTIVE ||
        s.status === SubscriptionStatus.TRIALING) &&
      s.sku === SYSTEM_SEND_STRIPE_ID,
  )
}

export default hasSystemPackage
